import { Input,  OnInit, OnDestroy, Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { EventManagerService } from '../service/event-manager.service';
import { SubscriptionService } from '../service/subscription.service';

@Injectable({ providedIn: 'root' })
export abstract class EditComponent implements OnInit, OnDestroy {
  @Input() queryParams: any = {};
  id: any;
  public editForm: any;
  detailObject: any = {};
  errors: any = {};
  isSaved: boolean = false;
  isUpload: boolean = false;
  isCalling: boolean = false;
  subscriptions?: Subscription[] = [];
  subsCommon?: Subscription[] = [];
  callApi$ = new Subject();
  infoForm: any;
  subscribeState: any;
  constructor(
    public eventManager: EventManagerService,
    public route: ActivatedRoute
  ) {
  }
  ngOnInit() {
    this.subscribeState = SubscriptionService.register(2, this.parseData.bind(this));
    const params = this.route.snapshot.params;
    this.id = params.id;
    if (this.id) {
      this.getDetail();
    }
    this.subsCommon =[
      this.eventManager.subscribe('upload-file', (res) => {
        this.isUpload = true;
      }),
      this.eventManager.subscribe('upload-fail', (res) => {
        this.isUpload = true;
      }),
      this.callApi$.pipe(
        debounceTime(500),
        ).subscribe((event)=> { return this.callAPI(event);})
    ];
  }
  ngOnDestroy() {
    this.eventManager.destroys(this.subscriptions);
    this.eventManager.destroys(this.subsCommon);
  }
  getDetail() {}
  onSuccess(res) {}
  onError(error) {}
  parseData() {}
  updateForm() {}
  disabledButton() {
    const keys = Object.keys(this.errors);
    const key = keys.find(key => this.errors[key]);
    return key ? true : false;
  }
  callAPI(event?) {
  }
  executeCallAPI(event?) {
    this.callApi$.next(event || true);
  }
  patchValue(field, value) {
    const body: any = {};
    body[field] = value;
    this.editForm.patchValue(body);
  }
  beforeSave() {
    this.isSaved =  true;
    const values = this.infoForm.value;
    Object.keys(values).forEach((key) => {
      if (values[key] === 'undefined') {
        const object = {};
        object[key] = undefined;
        this.infoForm.patchValue(object);
      }
    })
    const result = this.disabledButton();
    if (result || this.infoForm.invalid) {
      return true;
    }
  }
  save() {
    if (this.beforeSave()) {
      return;
    }
  }
}
